module.exports = require("@cimpress-technology/react-product-experience-rules");